<!-- <template src="DetailModal.html"></template> -->
<template src="../utils/DetailModal.html"></template>

<script setup>
    import { ref, watch, computed } from 'vue'

    // XSS Sanitization
    import DOMPurify from 'dompurify'
    import { HitBackEnd, ReArrange } from './formUtilsNew';
    import Swal from 'sweetalert2';
    import moment from 'moment';

    const props = defineProps({
          isOpen       : { type: Boolean, default: false }
        , isReadOnly   : { type: Boolean, default: false }
        , rowData      : { type: Object, default: () => ({}) }
        , columnDefs   : { type: Array, default: () => [] }
        , formConfig   : { type: Object, default: () => ({}) }
        , hiddenFields : { type: Array, default: () => [] }
        , columnsCustom: { type: Object, default: () => ({})}
        , formatsCustom: { type: Object, default: () => ({}) }    
        , typeMenu     : { type: String, default: '' }
    });

    // console.log("🚀 ~ rowData:", props.rowData.alias)
    // console.log("🚀 ~ isModalOpen:", props.isOpen)

    const emit         = defineEmits(['close', 'saved', 'approve', 'reject']);
    const editForm     = ref({});
    const isSaving     = ref(false);
    const isLoading    = ref(false)
    const modalError   = ref('');
    const modalSuccess = ref('');
    const userProfile  = ref(JSON.parse(localStorage.getItem('user_profile')))
    const level        = ref(userProfile.value.user_level)
    const typeMenu     = computed(() => props.typeMenu)
    const alias        = ref(props.rowData.alias)

    const isModalReadOnly = computed(() => {
        const gridElement = props.formConfig?.find(element => element.style === "grid");

        if (gridElement) {
            // console.log("🚀 ~ isReadOnly:", gridElement.isReadOnly);
            return Boolean(gridElement.isReadOnly);
        }
    });

    // Get Input Schema
    const schemaInputs = computed(() => {
        const sections = props.formConfig.tab || props.formConfig.card || [];
        const inputs = [];
        sections.forEach(sec => {
            if (Array.isArray(sec.input)) {
                inputs.push(...sec.input);
            }
        });
        return inputs;
    });

    const newModalFields = computed(() => {
        // console.log(`🚀 ~ "columnDefs":`, props.columnDefs)
        if (!props.rowData) return [];

        const rowKeys       = Object.keys(props.rowData);
        const fields        = [];
        const isMinus       = props.hiddenFields[0].includes('-')
        const newHideFields = props.hiddenFields.slice(1)
        // console.log("🚀 ~ newHideFields:", newHideFields)

        let data;
        let hasDurationColumn = false

        if (!isMinus) {
            const reArranged = ReArrange(newHideFields, [props.rowData]);
            const arrangedItem = reArranged[0] || {};

            Object.keys(arrangedItem).forEach((key) => {
                let val = arrangedItem[key];
                
                if (moment(val, moment.ISO_8601, true).isValid()) {
                    if (props.formatsCustom[key] === "tanggal") {
                        val = moment(val).format('LL');
                    } else if (props.formatsCustom[key] === "jam") {
                        val = moment(val).format('HH:mm');
                    }
                }

                const title = props.columnsCustom?.[key];

                if (val !== null && val !== undefined) {
                    fields.push({
                        label: title ?? getHeaderName(key),
                        value: val
                    });
                }
            });

        } else if (isMinus){
            rowKeys.forEach(key => {
                const isHidden = props.hiddenFields.includes(key)
                
                if(isHidden) return;

                data = props.rowData[key]
                    
                if (key === 'amount_day' || key === 'amount_hour') {
                    if (!hasDurationColumn) {
                            hasDurationColumn = true;
                            
                            const day  = Number(props.rowData.amount_day) || 0;
                            const hour = Number(props.rowData.amount_hour) || 0;
                            
                        fields.push({
                            label: 'Durasi',
                            value: day > 0 
                            ? `${day} Hari` 
                            : `${hour} Jam`
                        });
                    }
                    return;
                }
                
                if (moment(data, moment.ISO_8601, true).isValid() && props.formatsCustom[key] == "tanggal") {
                    data = moment(data).format('LL')   
                } else if (moment(data, moment.ISO_8601, true).isValid() && props.formatsCustom[key] == "jam") {
                    data = moment(data).format('HH:mm')  
                } 
                
                const title     = props.columnsCustom[key]
                
                if (data !== null && data !== undefined) {
                    fields.push({
                        label: title ?? getHeaderName(key)
                        , value: data
                    })
                }
                
                
            })
        }

        return fields;
        
    })

    // DYNAMIC MODAL FIELD GENERATOR
    const modalFields = computed(() => {
        if (!props.rowData) return [];

        const rowKeys = Object.keys(props.rowData);
        const fields = [];

        rowKeys.forEach(key => {
            const schemaDef = schemaInputs.value.find(i => i.id === key);
            console.log("🚀 ~ schemaDef:", schemaDef)

            // Check dynamically if field is in hiddenFields 
            const isHiddenInGrid     = props.hiddenFields.includes(key);
            const isExplicitReadOnly = isHiddenInGrid || schemaDef?.readonly === true;

            if (schemaDef) {
                fields.push({
                    ...schemaDef
                    , label     : schemaDef.label || getHeaderName(key)
                    , isReadOnly: isExplicitReadOnly
                });
            } else {

                fields.push({
                    id        : key
                    , label     : getHeaderName(key)
                    , type      : 'text'
                    , isReadOnly: isExplicitReadOnly
                });
            }
        });

        return fields;
    });

    watch(() => props.rowData, (newVal) => {
        if (newVal) {
            editForm.value = { ...newVal };
        }
    }, { immediate: true, deep: true });

    function getHeaderName(key) {
        const col = props.columnDefs.find(c => c.field === key);
        if (col && col.headerName) return col.headerName;
        return key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
    }

    // Sanitize form inputs before binding or rendering
    function sanitizeInput(val) {
        if (typeof val === 'string') {
            return DOMPurify.sanitize(val.trim())
        }
        return val
    }

    async function handleApprove() {
        isLoading.value = true

        console.log("🚀 ~ handleApprove ~ props.rowData:", props.rowData)

        try {
            const endPoint = "/api/webcms/approve"
            const payload  = {
                ep_code: props.rowData.code
            }
            
            const response = await HitBackEnd(endPoint, "post", payload)
            const result   = await response.json()

            if (result.statusCode == 200) {
                Swal.fire({
                      icon  : 'success'
                    , title : 'Approval Berhasil'
                    , text  : result.message
                }).then(() => {
                    emit('approve')
                    emit('close')
                })
            } else {
                Swal.fire({
                      icon  : 'error'
                    , title : 'Approval Gagal'
                    , text  : result.message
                })
            }
            
        } catch (error) {
            console.log("🚀 ~ handleApprove ~ error:", error)
            
        } finally {
            isLoading.value = false
        }
        
    }

    async function handleReject() {
        isLoading.value = true

        Swal.fire({
            title: 'Yakin?',
            text: 'Pengajuan akan di reject, tuliskan alasan reject pengajuan',
            icon: 'warning',
            input: 'text',
            showCancelButton: true,
            confirmButtonText: 'Ya, Reject'
        }).then(async result => {
            if (!result.isConfirmed) return;

            console.log(result.value);

            try {
                const endPoint = "/api/webcms/reject"
                const payload  = {
                    ep_code: props.rowData.code
                }
                
                const response = await HitBackEnd(endPoint, "post", payload)
                const result   = await response.json()

                if (result.statusCode == 200) {
                    Swal.fire({
                        icon  : 'success'
                        , title : 'Reject Berhasil'
                        , text  : result.message
                    }).then(() => {
                        emit('reject')
                        emit('close')
                    })
                } else {
                    Swal.fire({
                        icon  : 'error'
                        , title : 'Reject Gagal'
                        , text  : result.message
                    })
                }
                
            } catch (error) {
                console.log("🚀 ~ handleApprove ~ error:", error)
                
            } finally {
                isLoading.value = false
            }

        });

        
        
    }

    // Save Here !!!
    async function handleSave() {
        isSaving.value     = true;
        modalError.value   = '';
        modalSuccess.value = '';

        try {
            const baseUrl  = import.meta.env.VITE_API_URL || '';
            const endpoint = props.formConfig.save_endpoint || props.formConfig.read_endpoint;
            const token    = localStorage.getItem('auth_token');

            const payload = new URLSearchParams();
            Object.keys(editForm.value).forEach(key => {
                // payload.append(key, editForm.value[key] ?? '');

                // Apply sanitization before appending to API payload
                const cleanVal = sanitizeInput(editForm.value[key])
                payload.append(key, cleanVal ?? '');
            });

            const response = await fetch(`${baseUrl}${endpoint}`, {
                method : 'POST'
                , headers: {
                    'Content-Type' : 'application/x-www-form-urlencoded'
                    , 'Authorization': `Bearer ${token}`
                }
                ,body: payload
            });

            const api_resp = await response.json().catch(() => null);

            if (response.ok && api_resp?.success !== false) {
                modalSuccess.value = api_resp?.message || 'Updated successfully!';
                emit('saved', editForm.value);
                setTimeout(() => {
                    emit('close');
                }, 800);
            } else {
                modalError.value = api_resp?.message || `Error ${response.status}: Failed to save`;
            }
        } catch (err) {
            console.error('Save error:', err);
            modalError.value = 'Network error or unable to reach server.';
        } finally {
            isSaving.value = false;
        }
    }
</script>